<template>
  <edit-route-schedule />
</template>

<script>
import EditRouteSchedule from "@/components/3pl/Settings/RoutesAndVehicles/Routes/TerminalToTerminal/EditRoute/Edit/EditRouteSchedule";
export default {
  components: {
    EditRouteSchedule,
  },
};
</script>

<style></style>
